import { Component, inject } from '@angular/core';
import { map, Observable } from 'rxjs';
import { CounselUsersByType, UserExtended } from 'src/app/swagger-api';
import { GlobalCounselService } from './global-counsel.service';

interface CounselUsers {
  admins: UserExtended[];
  doctors: UserExtended[];
  patients: UserExtended[];
}

@Component({
  selector: 'app-global-counsel',
  templateUrl: './global-counsel.component.html',
  styleUrls: ['./global-counsel.component.scss'],
})
export class GlobalCounselComponent {
  public readonly counsels$: Observable<CounselUsers> = inject(GlobalCounselService)
    .getGSECUserList()
    .pipe(
      map(({ as_admin, as_doctor, as_patient }: CounselUsersByType) => ({
        admins: as_admin,
        doctors: as_doctor,
        patients: as_patient,
      })),
    );
}
